import * as BizCharts from 'bizcharts';
import { CHART_PRIMARY_COLOR, PERFORMER_SHAPE } from './LifeCycleAnalyticsConstants';

// SVG path coordinates for the asterisk marker (12x12 viewBox, center at 6,6)
// Combines an X shape and a + shape to form an 8-pointed asterisk
const ASTERISK_PATH_COORDS = {
	xShape: [
		[10.5978, 2.53173],
		[6.98137, 6.18131],
		[10.5978, 9.83089],
		[9.46877, 10.9467],
		[5.85234, 7.29716],
		[2.23591, 10.9467],
		[1.12695, 9.83089],
		[4.74338, 6.18131],
		[1.12695, 2.53173],
		[2.23591, 1.41553],
		[5.85234, 5.06511],
		[9.46877, 1.41553],
	],
	plusShape: [
		[11.1408, 6.78081],
		[6.85916, 6.78081],
		[6.85916, 11.0135],
		[4.84543, 11.0135],
		[4.84543, 6.78081],
		[0.563721, 6.78081],
		[0.563721, 4.78081],
		[4.84543, 4.78081],
		[4.84543, 0.548096],
		[6.85916, 0.548096],
		[6.85916, 4.78081],
		[11.1408, 4.78081],
	],
};

const buildAsteriskPath = (tx, ty) => {
	const path = [];
	const xCoords = ASTERISK_PATH_COORDS.xShape;
	const plusCoords = ASTERISK_PATH_COORDS.plusShape;

	path.push(['M', tx(xCoords[0][0]), ty(xCoords[0][1])]);
	for (let i = 1; i < xCoords.length; i++) {
		path.push(['L', tx(xCoords[i][0]), ty(xCoords[i][1])]);
	}
	path.push(['Z']);

	path.push(['M', tx(plusCoords[0][0]), ty(plusCoords[0][1])]);
	for (let j = 1; j < plusCoords.length; j++) {
		path.push(['L', tx(plusCoords[j][0]), ty(plusCoords[j][1])]);
	}
	path.push(['Z']);

	return path;
};

const SVG_CENTER = 6;

(BizCharts as any).G2.registerShape('point', PERFORMER_SHAPE.STAR, {
	draw: (cfg, container) => {
		const x = cfg.x;
		const y = cfg.y;
		const size = cfg.size || 6;
		const scale = size / SVG_CENTER;
		const fillColor = cfg.color || CHART_PRIMARY_COLOR;

		const tx = (sx) => {
			return x + (sx - SVG_CENTER) * scale;
		};
		const ty = (sy) => {
			return y + (sy - SVG_CENTER) * scale;
		};

		return container.addShape('path', {
			attrs: {
				path: buildAsteriskPath(tx, ty),
				fill: fillColor,
			},
		});
	},
	getMarker: (markerCfg) => {
		const color = markerCfg.color || CHART_PRIMARY_COLOR;
		return {
			symbol: (x, y, r) => {
				const s = r / SVG_CENTER;
				const tx = (sx) => {
					return x + (sx - SVG_CENTER) * s;
				};
				const ty = (sy) => {
					return y + (sy - SVG_CENTER) * s;
				};
				return buildAsteriskPath(tx, ty);
			},
			style: {
				fill: color,
				r: 5,
			},
		};
	},
});
